import React from 'react';

class ProjectorOption extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            cover : "null",
            helpMode : "None"
        };
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        var Pos = new window.Geo3DPoint(this.props.layer.VideoPOS.x , this.props.layer.VideoPOS.y , this.props.layer.VideoPOS.z);
        var V = new window.Geo3DPoint(this.props.layer.VideoV.x , this.props.layer.VideoV.y , this.props.layer.VideoV.z);
        var Up = new window.Geo3DPoint(this.props.layer.VideoUP.x , this.props.layer.VideoUP.y , this.props.layer.VideoUP.z);
        var Camera = new window.ov.Camera(Pos,V,Up);
        window.main.OView.gotoCamera(Camera, true);
    }
    coverChange(event){
        var cover = event.target.value;
        var ProjectorLayer = this.props.layer.layerHandel;
        if(cover === "null"){
            ProjectorLayer.setOverlayName();
            window.main.OView.updateScreen();
        }            
        else{
            ProjectorLayer.setOverlayName(cover);
            window.main.OView.updateScreen();
        }            
        this.setState({cover : cover});
    }
    render(){
        const Layer = this.props.layer;
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large find icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large disabled setting icon"></i>
                    </div>
                </div>
            </div>
        );
    }
}
class ProjectorLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            ProjectorLayer:{}
        };   
        this.ProjectorLayerChecked = this.ProjectorLayerChecked.bind(this);      
    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.ProjectorLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,ProjectorLayer:{}});
            }            
        }
    }
    ProjectorLayerChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if(!isChecked){
            var _Cust = window.main.OView.addCustomLayer({
                layername : layer.TITLE
            });
            var param = {};
            param.ImageType = window.ov.PROJECTOR_IMAGE.WIDE;
            param.SrcType = window.ov.PROJECTOR_SRC.VIDEO;
            param.VideoPath = layer.VideoPath;
            param.Pos = layer.VideoPOS;
            param.V = layer.VideoV;
            param.Up = layer.VideoUP;
            param.HFov = layer.HFov?layer.HFov:65;
            param.VFov = layer.VFov?layer.VFov:80;
            param.ImgW = layer.ImgW?layer.ImgW:5472; 
            param.ImgH = layer.ImgH?layer.ImgH:3648; 
            param.Near = layer.Near?layer.Near:5;
            param.Far = layer.Far?layer.Far:1000;            
            _Cust.addProjectorEntity(param);
            window.alertify.success("已開啟圖層："+layer.TITLE);
            layerThis.props.setOpenLayer(layer,_Cust);                        
            isChecked = !isChecked;  
            var Pos = new window.Geo3DPoint(layer.VideoPOS.x , layer.VideoPOS.y , layer.VideoPOS.z);
            var V = new window.Geo3DPoint(layer.VideoV.x , layer.VideoV.y , layer.VideoV.z);
            var Up = new window.Geo3DPoint(layer.VideoUP.x , layer.VideoPOS.y , layer.VideoUP.z);
            var Camera = new window.ov.Camera(Pos,V,Up);
            window.main.OView.gotoCamera(Camera, true);
            layerThis.setState({isChecked:isChecked,ProjectorLayer:_Cust});                 
        }
        else{
            window.main.OView.removeLayer(this.state.ProjectorLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            isChecked = !isChecked;    
            layerThis.setState({isChecked:isChecked,ProjectorLayer:{}});        
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="ProjectorLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.ProjectorLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {ProjectorLayer,ProjectorOption};